import { render } from "./PaiementAutreRecettes.vue?vue&type=template&id=dbb6b3dc&ts=true"
import script from "./PaiementAutreRecettes.vue?vue&type=script&lang=ts"
export * from "./PaiementAutreRecettes.vue?vue&type=script&lang=ts"

import "./PaiementAutreRecettes.vue?vue&type=style&index=0&id=dbb6b3dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__